import { render } from "./protocol_new_tour.vue?vue&type=template&id=633063e0"
import script from "./protocol_new_tour.vue?vue&type=script&lang=js"
export * from "./protocol_new_tour.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/inside/new_tour/protocol_new_tour.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "633063e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('633063e0', __exports__)) {
    console.log('reload')
    api.reload('633063e0', __exports__)
  }
  
  module.hot.accept("./protocol_new_tour.vue?vue&type=template&id=633063e0", () => {
    console.log('re-render')
    api.rerender('633063e0', render)
  })

}


export default __exports__